import {spRealDataTime, spUserDevice, userLogin} from "../until/api/SporePest";

/**
 * 虫情孢子登录获取token
 */
export default {
  getSpToken(param, callback) {
    userLogin(param).then(response => {
      callback(response.data.data.token);
    }).catch(error => {
      console.log("error", error);
    })
  },

  /**
   * 获取虫情孢子设备列表
   * @param callback
   */
  getSpDeviceList(callback) {
    spUserDevice().then(response => {
      callback(response.data);
    }).catch(error => {
      console.log("error", error)
    })
  },

  /**
   * 获取虫情孢子实时数据
   * @param deviceAddr
   * @param callBack
   */
  spRealDataTime(deviceAddr, callBack) {
    spRealDataTime(deviceAddr).then(response => {
      callBack(response.data);
    }).catch(error => {
      console.log("error", error);
    })
  },
}



// WEBPACK FOOTER //
// ./src/tool/SporeSoilCommon.js